import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedDTO } from 'src/app/Common/common.interface';
import { notificationMaster_Create, notificationMaster_readAllPaginated, notificationMaster_UpdateStatusById, WhatsAppConfig_readAllPaginated } from 'src/app/GlobalVariables';
import { WhatsAppConfigList } from '../whatsapp-config/whatsapp-config.interface';
import { NotificationHistoryDTO, NotificationHistoryList, NotificationHistoryReadAllPaginatedRequestDTO, NotificationHistoryUpdateStatusByIdRequestDTO, NotificationMaster_CreateRequestDTO } from './history.interface';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  constructor() { }
    http = inject(HttpClient)

    history_readAllPaginated(data: NotificationHistoryReadAllPaginatedRequestDTO): Observable<NotificationHistoryList> {
      return this.http.post<NotificationHistoryList>(notificationMaster_readAllPaginated,data);
    }

    notificationMaster_Create(data:NotificationMaster_CreateRequestDTO):Observable<NotificationHistoryDTO>{
      return this.http.post<NotificationHistoryDTO>(notificationMaster_Create, data);
    }

    notificationMaster_UpdateStatusById(data:NotificationHistoryUpdateStatusByIdRequestDTO):Observable<NotificationHistoryDTO>{
      return this.http.post<NotificationHistoryDTO>(notificationMaster_UpdateStatusById, data);
    }
}
